import BrandEnteties from "./BrandEnteties";

export default BrandEnteties;
